export default __webpack_public_path__ + "static/media/Valorant.9145bf11.jpg";